import React, { Component } from 'react'; 
import { withStyles, Paper, Typography, TextField, Button, MenuItem, Divider, FormLabel, FormControl, FormControlLabel, FormHelperText, FormGroup, Checkbox, Grid } from '@material-ui/core';
import { } from '@material-ui/icons';
import Select from 'react-select';
import creds from '../config/firebaseConfig';
import db from '../config/firestoreConfig';


const styles = theme => ({
    root: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
      margin: 'auto',
      width: '75%',
      overflowX: 'auto'
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
      },
      paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        height: 'auto',
        overflowX: 'auto'
    },
      textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 300,
        padding: 5,
      },
      menu: {
        width: 200,
      },
      button: {
        margin: theme.spacing.unit,
      },
      input: {
        display: 'none',
      },
});

const userGroups = [
    { 
        value: 'Student',
        label: 'Student'
    },
    {
        value: 'Teacher',
        label: 'Teacher'
    }, 
    {
        value: 'Parent',
        label: 'Parent'
    }, 
]

class CreateAccount extends Component { 
    constructor(props) { 
        super(props)
        this.state = {
            levels: [], 
            students:[],
            years: [],
            abilities: ['Beginner', 'Intermediate', 'Advanced'],
            newUser: {
                email:  '',
                displayName: '', 
                password: '',
                UID: '',
                activated: false,
                Access: [],
                CurrentLevel: '',
                accountType: '', 
                CurrentYear: '',
                ability: '',
                target: 0,
            }
        }
        this.createUser = this.createUser.bind(this);
    }

    componentDidMount = () => {
        var levels = []
        var arr= []
        var years = [] 
        db.collection('Level').get()
            .then(snapshot => {
                snapshot.forEach(option => {
                    this.state.levels.push(option.id)
                    var obj = []
                    var ref = db.collection('Level').doc(option.id).collection('Subjects')
                    ref.get()
                        .then(snapshot => { 
                            snapshot.forEach(subject => { 
                                ref.doc(subject.id).collection('Years').get()
                                    .then(snapshot => { 
                                        snapshot.forEach(year => { 
                                            if (!obj.includes(year.id)){
                                                obj.push(year.id)
                                            }
                                        })
                                    })
                            })
                            this.state.years.push(obj)
                        }) 
            })
        })

        db.collection('Users').where('accountType', '==', 'Student').get()
            .then(snapshot => {
                var arr = [] 
                snapshot.forEach(doc => { 
                    var obj = {
                        
                        label: doc.data().displayName,
                        value: doc.data().UID,
                        name: doc.data().displayName,
                    
                    }
                    arr.push(obj)
                })
                this.setState({
                    ...this.state,
                    students: arr
                })
                console.log('arr', arr)
            })
        //when Weve pulled everything, push it all to the state
    }

    handleChange = name => event => {
        var state
        if (name == 'password') {
             state = {
                ...this.state,
                [name]: event.target.value,
                newUser: {
                    ...this.state.newUser,
                    [name]: event.target.value,
                },
                displayNameError: false,
                emailError: false,
                accountTypeError: false,
                passwordError: false,
                levelError: false, 
                yearError: false,
                abilityError: false,
                targetError: false
            } 
        } else {
             state = {
            newUser: {
                ...this.state.newUser,
                [name]: event.target.value,
            },
            displayNameError: false,
            emailError: false,
            accountTypeError: false,
            passwordError: false,
            levelError: false, 
            yearError: false,
            abilityError: false,
            targetError: false

        };

    }
        
        
        this.setState(state)
        // console.log(this.state) //debug line
    };



    finalHandleClick = (name) => event => {
        const state = {
            newUser: { 
                ...this.state.newUser,
                Access: {
                    //try
                    ...this.state.newUser.Access,
                    [name]: event.target.checked,
            }
        }
    }
        this.setState(state)
  };

    clearState = () => { 
        this.setState({
            newUser: {
            email:  '',
            displayName: '', 
            UID: '',
            activated: false,
            Access: []
            }, 
            createError: false ,
            password: '', 
        })
    }

    getSubjects = async (name) => { 
        var arr = [] 
        console.log(name)
        var ref = db.collection('Level').doc(name).collection('Subjects')
        var search = await ref
        search.get()
            .then(snapshot => { 
                snapshot.forEach(doc => {
                    ref.doc(doc.id).collection('Years').get()
                        .then(snapshot => {
                            snapshot.forEach(year => {
                                if (!arr.includes(year.id)){
                                    arr.push(year.id)
                                    this.state.years.push(year.id)
                                }
                            })
                        })
                })
            })
            console.log(arr)
            return arr
    }
    
    createUser = (userObj) => {
        console.log(userObj)
        if (userObj.displayName.length  <= 0){ 
            return this.setState({displayNameError :true})
        } else
        if ( userObj.email.length <= 0 || !userObj.email.includes('@') || !userObj.email.includes('.')){
            return this.setState({emailError: true})
        } else 
        if ( this.state.password.length < 6) {
            return this.setState({passwordError: true})
        } else 
        if (userObj.accountType.length <= 0) { 
            return this.setState({accountTypeError: true})
        } else 
        if (userObj.accountType == 'Student' && userObj.CurrentLevel.length <= 0) { 
            return this.setState({levelError: true})
        } else 
        if (userObj.accountType == 'Student' && userObj.CurrentYear.length <= 0) { 
            return this.setState({yearError: true})
        } else 
        if (userObj.accountType == 'Student' && userObj.ability.length <= 0) { 
            return this.setState({abilityError: true})
        }   else 
        if (userObj.accountType == 'Student' && userObj.target <= 0) { 
            return this.setState({targetError: true})
        } else 
        if (userObj.accountType == 'Parent' && this.state.selected <= 0) { 
            return window.alert('No Children assigned to parent account')
        } else 
        if (userObj.accountType == 'Student' && parseInt(userObj.target) > 100) { 
            return this.setState({targetError: true})
        } 
        userObj.OGPassword = this.state.password
        userObj.target = parseInt(userObj.target)
        
        console.log(this.state)
        creds.secondaryfb.auth().createUserWithEmailAndPassword(userObj.email, userObj.password)
            .then( user => { 
                console.log('User created')
                        console.log(user.user.uid)
                        var uid = user.user.uid
                        console.log(this.state)
                        this.setState({ newUser: {
                            ...this.state.newUser,
                            UID: uid
                        }})
                        if (this.state.newUser.accountType == 'Student') { 
                            db.collection('Level').doc(this.state.newUser.CurrentLevel).collection('Subjects').get()
                                        .then(snapshot => {
                                            snapshot.forEach(subject => {
                                                const docRef = db.collection('Level').doc(userObj.CurrentLevel).collection('Subjects').doc(subject.id).collection('Years').doc(userObj.CurrentYear).collection('Abilities').doc(userObj.ability)
                                                console.log(subject.id)
                                                console.log(this.state)
                                                var members = []
                                                docRef.get()
                                                    .then(snapshot => {
                                                        // console.log(snapshot, snapshot.data())
                                                        try { 
                                                        members = snapshot.data().data.Members
                                                        members.push(uid)
                                                        docRef.set({
                                                            data:{ Members: members}
                                                        }, {merge: true})
                                                    } catch (err) {
                                                        var abilityArr = ['Beginner', 'Intermediate', 'Advanced']
                                                        abilityArr.forEach(ability => {
                                                            db.collection('Level').doc(userObj.CurrentLevel).collection('Subjects').doc(subject.id).collection('Years').doc(userObj.CurrentYear).set({id: userObj.CurrentYear})
                                                                .then((() => { 
                                                                    db.collection('Level').doc(userObj.CurrentLevel).collection('Subjects').doc(subject.id).collection('Years').doc(userObj.CurrentYear).collection('Abilities').doc(ability).set({
                                                                        data: {
                                                                            Classes: [],
                                                                            Content: {
                                                                                Sections: [],
                                                                            },
                                                                            Members: [uid]
                                                                        }
                                                                    })
                                                                }))
                                                        })
                                                        return window.alert('There was an error creating this student because ' + subject.id  + ' had no group; year ' + userObj.CurrentYear + '. So the year group was created for you and ' + userObj.displayName + ' has been enrolled. For future reference it is best to create subject and year groups first.')
                                                    }
                                                    })
                                            })
                                        })
                            userObj.UID = uid
                            db.collection('Users').add(
                                userObj
                            )
                            .then(()=> {
                                window.alert('Account created')
                                this.clearState()
                            })
                        };
                        

                        if (this.state.newUser.accountType == 'Parent'){
                            var newParent = this.state.newUser
                            console.log('NEW PARENT', newParent)
                            newParent['children'] = this.state.selected
                            db.collection('Users').add(
                                newParent
                            )
                            .then(function(docRef) {
                            console.log('Document written with ID:  ', docRef.id, 'data:', newParent)
                            window.alert('Account Created')   
                            })
                            .then(() => {
                                this.clearState()
                            })
                                
                            
                            
                            .catch(function(error){
                                console.log(error)
                            })
                        }
                        
                        if (this.state.newUser.accountType == 'Teacher'){
                            db.collection('Users').add(
                                this.state.newUser
                            )
                            .then(function(docRef) {
                            console.log('Document written with ID:  ', docRef.id)
                            setTimeout(window.alert('Account Created'), 500)
                            })
                            .then(() => {
                                this.clearState()
                            })
                                
                            
                            
                            .catch(function(error){
                                console.log(error)
                            })
                        }
                        
                        
                    
                 
                creds.secondaryfb.auth().signOut();
            })
            .catch(function(error){
                console.log('there was an error creating this user: ' + error)
            })
                
    }   

    handleCheck = (opt, meta)  => {
        // console.log('handle Check started')
        // console.log(opt, meta)
        var arr = []
        opt.forEach(student => { 
            arr.push(student)
        })
        console.log(arr)
        this.setState({selected: arr})
    }

    render() { 
        const { classes } = this.props
        return (
            <div>
                <Paper className={classes.root} elevation={1}>
                    <Typography variant="headline" component="h3">
                        Create Accounts 
                    </Typography>
                    <Divider/>
                    <br/>
                    <Grid container
                        spacing={24}
                        direction='row'
                        justify='space-evenly'
                        alignContent='center'
                        style={{overflowX: 'auto'}}
                    >
                        <Grid item xl={3} lg={12}> 
                            <Paper className={classes.paper}>
                                <Grid container
                                    spacing={24}
                                    direction='row'
                                    justify='space-evenly'
                                    alignContent='center'
                                    style={{overflowX: 'auto'}}
                                >
                                    <Grid item xs={12}>
                                        <Typography variant='title'>
                                            New User Account Info
                                            <Divider/>
                                        </Typography>
                                        <form className={classes.container} >
                                        <div style={{ paddingTop: 'auto', width: 'auto', margin: 'auto'}}>
                                            <TextField
                                                id='name'
                                                className={classes.textField}
                                                value={this.state.newUser.displayName}
                                                onChange={this.handleChange('displayName')}
                                                margin='normal'
                                                placeholder='Please enter the users display name'
                                                error={this.state.displayNameError}
                                            />
                                            <br/>
                                            <TextField
                                                id='email'
                                                type='email'
                                                className={classes.textField}
                                                value={this.state.newUser.email}
                                                onChange={this.handleChange('email')}
                                                margin='normal'
                                                placeholder='Please enter the users Email'
                                                error={this.state.emailError}
                                            />
                                            <br/>
                                            <TextField
                                                id='password'
                                                type='password'
                                                className={classes.textField}
                                                value={this.state.password}
                                                onChange={this.handleChange('password')}
                                                margin='normal'
                                                placeholder='Accounts password - min 6 chars'
                                                error={this.state.passwordError}
                                            />
                                            <br/>
                                            <TextField
                                                id='userGroup'
                                                select
                                                label='     Is the user a Student, Teacher or Admin'
                                                className={classes.textField}
                                                value={this.state.newUser.accountType}
                                                onChange={this.handleChange('accountType')}
                                                margin='normal'
                                                helperText='Please select one'
                                                error={this.state.accountTypeError}
                                            >
                                            {userGroups.map(option => (
                                                <MenuItem key={option.value} value={option.value}> 
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                            </TextField>
                                            <br/>
                                            <div>
                                            {(this.state.newUser.accountType === 'Student') ? 
                                                <div>
                                                    <TextField
                                                        id='Level'
                                                        select
                                                        label='Please select the suitable Academic level'
                                                        className={classes.textField}
                                                        value={this.state.newUser.CurrentLevel}
                                                        onChange={this.handleChange('CurrentLevel')}
                                                        margin='normal'
                                                        helperText='Please select one'
                                                        error={this.state.levelError}
                                                    >
                                                            {this.state.levels.map(level => (
                                                                <MenuItem key={this.state.levels.indexOf(level)} value={level}> 
                                                                    {level}
                                                                </MenuItem>
                                                            ))}
                                                    </TextField> 
                                                    <br/>
                                                    <TextField
                                                        id='Year'
                                                        select
                                                        label='Please select the suitable year'
                                                        className={classes.textField}
                                                        value={this.state.newUser.CurrentYear}
                                                        onChange={this.handleChange('CurrentYear')}
                                                        margin='normal'
                                                        helperText='Please select one'
                                                        error={this.state.yearError}
                                                    >
                                                            {(this.state.newUser.CurrentLevel ? 
                                                            this.state.years[this.state.levels.indexOf(this.state.newUser.CurrentLevel)].map(year => (
                                                                <MenuItem key={this.state.years.indexOf(year)} value={year}> 
                                                                        {year}
                                                                    </MenuItem>
                                                                
                                                            ))
                                                            :
                                                            <div/>)}
                                                    </TextField> 
                                                    <br/>
                                                    <br/>
                                                    <TextField
                                                        id='Ability'
                                                        select
                                                        label='What is the suitable ability level'
                                                        className={classes.textField}
                                                        value={this.state.newUser.ability}
                                                        onChange={this.handleChange('ability')}
                                                        margin='normal'
                                                        helperText='Please select one'
                                                        error={this.state.abilityError}
                                                    >
                                                    {this.state.abilities.map(option => (
                                                        <MenuItem key={option} value={option}> 
                                                            {option}
                                                        </MenuItem>
                                                    ))}
                                                    </TextField>
                                                    <br/>
                                                    <TextField
                                                        id='Target'
                                                        label='What is a suitable Target mark (%)'
                                                        type='number'
                                                        className={classes.textField}
                                                        value={this.state.newUser.target}
                                                        onChange={this.handleChange('target')}
                                                        error={this.state.targetError}
                                                    />
                                                    <br/>
                                                </div>  
                                            :
                                                (this.state.newUser.accountType == 'Parent' ? 

                                                <div className={classes.textField}>
                                                    <br/>
                                                    <Typography variant='subheading'>
                                                        Please assign children to {this.state.newUser.displayName}
                                                    </Typography>
                                                    <Select 
                                                            options={this.state.students} 
                                                            maxMenuHeight={150}
                                                            isMulti
                                                            onChange={(opt, meta) => this.handleCheck(opt, meta)}
                                                            error
                                                    />
                                                </div> 
                                                    :

                                                    <div/>
                                                )
                                            }  
                                            </div>
                                            
                                            <Button variant='contained' className={classes.button} onClick={() => this.createUser(this.state.newUser)}>
                                                Create
                                            </Button>   
                                        </div>
                                        </form>
                                    </Grid>
                                 </Grid>
                            </Paper>
                            <br/>
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        )
    }
}

export default withStyles(styles)(CreateAccount); 




// WEBPACK FOOTER //
// ./src/pages/createAccount.jsx